<template>
  <div class="pt-5">
    <v-data-table
      :items="solicitudes"
      :headers="headers"
      :loading="loading"
      no-data-text="Sin solicitudes para mostrar"
      no-results-text="Sin resultados para mostrar"
      loading-text="Cargando..."
      :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
      :server-items-length="total"
      @update:page="pagina = $event"
      @update:items-per-page="elementosPagina = $event"
    >
      <template v-slot:top>
        <v-row style="padding: 15px;">
          <v-col cols="12" md="8">
            <h2>Resultados de la búsqueda</h2>
          </v-col>
        </v-row>
      </template>
      <template #item.cliente="{ item }">
        <span>{{
          `${item.nombre ? item.nombre + " " : ""}${
            item.apellidoPaterno ? item.apellidoPaterno + " " : ""
          }${item.apellidoMaterno ? item.apellidoMaterno : ""}`
        }}</span>
      </template>
      <template #item.alianzaIntermxId="{ item }">
        <span>{{ getAlianzaName(item.alianzaIntermxId) }}</span>
      </template>
      <template #item.fechaCreacion="{ item }">
        <span>{{ getFormatDate(item.fechaCreacion) }}</span>
      </template>
      <template #item.ver="{ item }">
        <v-btn icon x-small @click="verSolicitud(item.id)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        <div v-if="itemsLength">
          Mostrando {{ pageStart }} - {{ pageStop }} de
          {{ itemsLength }} solicitudes
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getUsersList } from "@/services/user/user.service";
import { getAlianzasList } from "@/services/alianzas/alianzas.service.js";
import moment from "moment";

export default {
  components: {},
  props: {
    solicitudes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    restartPaginacion: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: "Número",
          value: "id",
        },
        {
          text: "Estado",
          value: "status",
        },
        {
          text: "Fecha",
          value: "fechaCreacion",
        },
        {
          text: "Tipo",
          value: "tipo",
        },
        {
          text: "Categoría",
          value: "categoria",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        {
          text: "Alianza",
          value: "alianzaIntermxId",
        },
        {
          text: "Certificado",
          value: "certificado",
        },
        {
          text: "Ver",
          value: "ver",
        },
      ],
      solicitudSeeleccionada: "",
      dialog: false,
      usuarios: [],
      elementosPagina: 10,
      pagina: 1,
      alianzas: [],
    };
  },
  watch: {
    pagina(v) {
      if (v)
        this.$emit("paginacionModificada", {
          pagina: v,
          elementosPagina:
            this.elementosPagina > 0 ? this.elementosPagina : this.total,
        });
    },

    elementosPagina(v) {
      if (v)
        this.$emit("paginacionModificada", {
          pagina: this.pagina,
          elementosPagina: v > 0 ? v : this.total,
        });
    },
    restartPaginacion(v) {
      if (v) {
        this.pagina = 1;
        this.elementosPagina = 10;
        this.$emit("restartFlag");
      }
    },
  },

  methods: {
    verSolicitud(id) {
      this.$router.push(`/detalles-solicitud/${id}`);
    },
    seleccionarItem(id) {
      this.solicitudSeeleccionada = id;
      this.dialog = true;
    },
    getNombre(id) {
      let usuario = this.usuarios.find((e) => e.id == id);
      return usuario ? usuario.nombreCompleto : "No disponible";
    },
    async getUsersList() {
      this.usuarios = await getUsersList();
    },
    getFormatDate(date) {
      return moment(date)
        .subtract(6, "hours")
        .format("DD/MM/YYYY hh:mm:ss");
    },
    async getAlianzas() {
      let response = await getAlianzasList();
      this.alianzas = response.data;
    },
    getAlianzaName(id) {
      console.log(id);
      let alianza = this.alianzas.find((e) => e.id == id);
      return alianza ? alianza.nombre : "";
    },
  },
  mounted() {
    this.getUsersList();
    this.getAlianzas();
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}
</style>
